export const isEnteringViewport = (el: any) => {
	const rect = el.getBoundingClientRect()
	return rect.top <= 650
}

export const isInViewport = (el: any) => {
	const rect = el.getBoundingClientRect()
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}
